/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  flight: 'flight',
  stops: 'stops',
  oneway: 'oneway',
  roundtrip: 'roundtrip',
  to: 'to'
}; export default Keys;